"use client";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import Header from "../Header";
import Footer from "../Footer";
import { FiPlus, FiMinus } from "react-icons/fi";
import { useCart } from "../../context/CartContext";
import { useSubscription } from "../../context/SubscriptionContext";
import { useAddress } from "../../context/AddressContext";
import { BASE_URL, UPLOAD_URL, PAYMENT_URL } from "../../config/apiConfig";
import { OrdersContext } from "../../context/OrdersContext";
import { useProfile } from "../../context/ProfileContext";

const allowedQuantities = [1, 2, 3, 4, 5, 6, 7];

const getCartPriceByQuantity = (totalQty) => {
  switch (totalQty) {
    case 1:
      return 15;
    case 3:
      return 35;
    case 5:
      return 50;
    case 7:
      return 60;
    default:
      return 0;
  }
};

const Cartsection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { cart, addToCart, removeFromCart } = useCart();
  const { removeFromSubCart, cart: subscriptionCart, hasSubscribedBefore  } = useSubscription();
  // const { addresses, fetchAddresses } = useAddress();
  const { addresses, fetchAddresses, activeAddress } = useAddress();

  const { placeOrder } = useContext(OrdersContext);
  const [subCartCleared, setSubCartCleared] = useState(false);

const [showInfoModal, setShowInfoModal] = useState(false);
const [infoModalMessage, setInfoModalMessage] = useState("");

// OTP Modal States
const [showModal, setShowModal] = useState(false);
const [isVerified, setIsVerified] = useState(false);
const [otp, setOtp] = useState(Array(6).fill(""));
const [modalType, setModalType] = useState(""); // "email" or "phone"
const [email, setEmail] = useState("");
const [mobile, setMobile] = useState("");
const [countryCode, setCountryCode] = useState("+91");
const { verifyEmailOtp, verifyMobileOtp } = useProfile();

  const [showAddressList, setShowAddressList] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [subCart, setSubCart] = useState([]);
    useEffect(() => {
      window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
    }, []);

  // Fetch addresses and sub_cart from localStorage
  useEffect(() => {
    fetchAddresses();
    const storedSubCart = localStorage.getItem("sub_cart");
    if (storedSubCart) {
      setSubCart(JSON.parse(storedSubCart));
    }
  }, []);

  // Auto-select first address when addresses are loaded
 useEffect(() => {
  if (activeAddress) {
    setSelectedAddress(activeAddress);
  }
}, [activeAddress]);

  // Listen for changes in subscription cart
  useEffect(() => {
    setSubCart(subscriptionCart);
  }, [subscriptionCart]);


  const handleOtpChange = (val, idx) => {
  if (/^[0-9]?$/.test(val)) {
    const newOtp = [...otp];
    newOtp[idx] = val;
    setOtp(newOtp);
  }
};
const handleConfirmCode = async () => {
  const email =
    typeof window !== "undefined" ? localStorage.getItem("uemail") : null;
  const otpCode = otp.join("");
  if (otpCode.length !== 6) return alert("Enter all 6 digits");

  let res;
  if (modalType === "email") {
    res = await verifyEmailOtp({ email, otp: otpCode });
  } else if (modalType === "phone") {
    res = await verifyMobileOtp({ mobile: `${countryCode} ${mobile}`, otp: otpCode });
  }

  if (res?.status === 200) {
    setIsVerified(true);
    setTimeout(() => {
      setShowModal(false);
      setIsVerified(false);
      setOtp(Array(6).fill(""));
    }, 2000);
  } else {
    alert(res?.message || "Invalid OTP");
  }
};

  // Listen for localStorage changes (e.g., sub_cart cleared externally)
  useEffect(() => {
    const handleStorageChange = () => {
      const storedSubCart = localStorage.getItem("sub_cart");
      if (storedSubCart) {
        setSubCart(JSON.parse(storedSubCart));
      } else {
        setSubCart([]);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Also check on mount in case it was cleared before
    handleStorageChange();

    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Decide which cart to show
  const displayCart =
  subCart.length > 0
    ? subCart
    : subCartCleared
    ? [] // 🧩 If subCart was just cleared, show empty
    : cart;

  const isSubCart = subCart.length > 0;

  const totalQuantity = displayCart.reduce((sum, item) => sum + item.quantity, 0);

  // Use item.price for sub_cart, getCartPriceByQuantity for normal cart
  const cartTotal = isSubCart
    ? displayCart.reduce((sum, item) => sum + Number(item.price || 0), 0)
    : getCartPriceByQuantity(totalQuantity);

  const discount = 2;
  const grandTotal = Math.max(cartTotal - discount, 0);
  const isEvenQuantity = totalQuantity % 2 === 0 && totalQuantity !== 0;
  const maxCartQty = 7;

  const increaseQty = (id) => {
    if (isSubCart) return; // do not allow changing quantity for sub_cart
    const item = cart.find((i) => i.id === id);
    if (!item) return;

    const currentIndex = allowedQuantities.indexOf(item.quantity);
    const nextIndex = Math.min(currentIndex + 1, allowedQuantities.length - 1);
    const nextQty = allowedQuantities[nextIndex];
    const newTotalQty = totalQuantity - item.quantity + nextQty;
    if (newTotalQty > maxCartQty) {
      alert("You can only add up to 7 items in total.");
      return;
    }
    addToCart(item, nextQty);
  };

  const decreaseQty = (id) => {
    if (isSubCart) return;
    const item = cart.find((i) => i.id === id);
    if (!item) return;

    const currentIndex = allowedQuantities.indexOf(item.quantity);
    const prevIndex = Math.max(currentIndex - 1, 0);
    const prevQty = allowedQuantities[prevIndex];
    addToCart(item, prevQty);
  };

  // 📬 For subscription cart
const handleSubscriptionOrder = async () => {
  if (displayCart.length === 0) {
    alert("Subscription cart is empty.");
    return;
  }

  // ✅ Require address selection for subscription order too
  if (!selectedAddress) {
    alert("⚠️ Please select a delivery address before proceeding to payment.");
    setShowAddressList(true); // open the address selection modal
    return;
  }

  const user_id = localStorage.getItem("user_id");
  if (!user_id) {
    alert("User ID not found. Please log in again.");
    navigate("/login");
    return;
  }

    const address_id = selectedAddress?.id;
    const totalAmount = isSubCart ? cartTotal : grandTotal;

  try {
    for (const item of displayCart) {
      const payload = {
        user_id: Number(user_id),
        address_id,
        plan_id: Number(item.id),
        totalAmount,
        create_audit_id: Number(user_id),
      };

      const response = await fetch(`${BASE_URL}/subscription/place-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      // console.log("Subscription Order Response:", data);

      // ✅ Handle already active subscription
      if (data.status === 202) {
        setInfoModalMessage(data.message);
        // setShowInfoModal(true);
        return;
      }


      if (data.status !== 201) {
        alert(data.message || "Subscription order failed.");
        console.error("Subscription order failed:", data);
        return;
      }

      const orderId = data.subscription_id;

      // Create Stripe session for payment
      const stripePayload = {
        orderId,
        total: Number(item.price),
        user_id: Number(user_id),
      };

      const stripeSessionRes = await fetch(
        `${PAYMENT_URL}/stripepayment/createSubCheckoutSession`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(stripePayload),
        }
      );

      const stripeData = await stripeSessionRes.json();

      if (stripeData.url) {
        window.location.href = stripeData.url; // redirect to Stripe
        return;
      } else {
        alert("Failed to create Stripe payment session.");
        console.error("Stripe session creation failed:", stripeData);
        return;
      }
    }
  } catch (error) {
    console.error("Subscription order error:", error);
    alert("Failed to place subscription order.");
  }
};

const [activeOrderMessage, setActiveOrderMessage] = useState(null);


const handleProceed = async () => {

  if (displayCart.length === 0) {
    // console.warn("Cart is empty.");
    alert("Cart is empty.");
    return;
  }

  const user_id = localStorage.getItem("user_id");
  // console.log("User ID from localStorage:", user_id);

  if (!user_id) {
    alert("User not logged in. Please log in.");
    navigate("/login");
    return;
  }

  if (!selectedAddress) {
    // console.warn("No delivery address selected.");
    alert("⚠️ Please select a delivery address before proceeding to payment.");
    setShowAddressList(true);
    return;
  }

  const totalAmount = isSubCart ? cartTotal : grandTotal;
  const address_id = selectedAddress?.id;

  // Prepare order data
  const orderData = {
    user_id,
    address_id,
    create_audit_id: user_id,
    total_amount: cartTotal,
    total_quantity: totalQuantity,
    products: displayCart.map((item) => ({
      product_id: item.id,
      quantity: item.quantity,
      price: Number(item.price || getCartPriceByQuantity(item.quantity)),
      offer_price: Number(item.offer_price || item.price || getCartPriceByQuantity(item.quantity)),
    })),
  };

  // console.log("Order data to be sent:", orderData);

  let result;
  try {
    result = await placeOrder(orderData);

    if (!result.status) {
      // If there's an error message (like 403), display it
      setActiveOrderMessage(result.error); // Show the error message
      return; // Stop further processing
    }

    // console.log("Response from placeOrder:", result);
  } catch (err) {
    // console.error("Failed to place order:", err);
    alert("Failed to place order. Please try again.");
    return;
  }

  if (!result.status) {
    // console.error("Order placement failed:", result.error);
    alert(result.error || "Order placement failed.");
    return;
  }

  navigate(`/PaymentSuccess/${result.order_id}`);
  // console.log("Order placed successfully, order_id:", result.order_id);

  // try {
  //   const response = await fetch(`${PAYMENT_URL}/stripepayment/createCheckoutSession`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({
  //       orderId: result.order_id,
  //       total: totalAmount,
  //     }),
  //   });

  //   const data = await response.json();
  //   if (data.url) {
  //     window.location.href = data.url;
  //   } else {
  //     alert(data.error || "Payment initialization failed");
  //   }
  // } catch (error) {
  //   alert("Payment initialization failed");
  // }
};

// Terms and conditions checkbox
const [agreeTerms, setAgreeTerms] = useState(false);
const [termsError, setTermsError] = useState("");

  // Handle navigation to add address with proper state management
  const handleAddNewAddress = () => {
    navigate("/Address", {
      state: {
        returnTo: "/cartsection",
        fromCart: true
      }
    });
  };

  return (
    <div className="font-poppins">
      <Header />

      <main className="flex gap-7 p-10 w-full min-h-[800px] bg-neutral-50 max-xl:flex-col max-xl:gap-5 max-md:p-5 max-sm:p-4">
        <section className="flex flex-col flex-1 min-w-0">
          <Breadcrumb />

          <div className="flex flex-col md:flex-row justify-between gap-12 p-6 bg-gray-50 ">
            {/* Cart Items */}
       <div className="w-full lg:w-2/3 bg-white rounded-xl shadow-md p-4">
  <h2 className="text-lg font-semibold mb-4 text-gray-900">Cart Items</h2>

  <div className="flex flex-col gap-4">
    {displayCart.length === 0 ? (
      <p className="text-gray-500">Your cart is empty.</p>
    ) : (
      displayCart.map((item) => {
        const currentIndex = allowedQuantities.indexOf(item.quantity);
        return (
          <div
            key={item.id}
            className="border p-4 rounded-lg flex flex-col md:flex-col lg:flex-row lg:items-center lg:justify-between gap-4 bg-white"
          >
            {/* 🖼️ Image + Name (always together) */}
          <div className="flex items-start gap-3 w-full min-w-0">

              {!isSubCart && (
                <img
                  src={
                    item.image
                      ? item.image.startsWith("http")
                        ? item.image
                        : `${UPLOAD_URL}/products/${item.image}`
                      : "https://via.placeholder.com/150"
                  }
                  alt={item.name || "Product"}
                  className="w-16 h-16 sm:w-20 sm:h-20 rounded-md object-cover"
                />
              )}
             <span
  className="
    font-medium text-gray-800
    text-sm sm:text-base
    leading-snug
    overflow-hidden
    text-ellipsis
    display-webkit-box
    line-clamp-2
    break-words
  "
  title={item.name}
>
  {item.name}
</span>

            </div>

            {/* ➕➖ Quantity Controls + Remove Button */}
            {/* ➕➖ Quantity Controls + Remove Button */}
<div className="flex items-center justify-between gap-3 flex-nowrap flex-shrink-0 w-full sm:w-auto">
  {!isSubCart && (
    <>
      <button
        disabled={currentIndex <= 0}
        onClick={() => decreaseQty(item.id)}
        className={`w-8 h-8 flex items-center justify-center rounded-full bg-[#002347] text-white hover:bg-[#003366] transition ${
          currentIndex <= 0 ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        <FiMinus size={16} />
      </button>

      <span className="font-medium text-gray-800">{item.quantity}</span>

      <button
        disabled={currentIndex === allowedQuantities.length - 1}
        onClick={() => increaseQty(item.id)}
        className={`w-8 h-8 flex items-center justify-center rounded-full bg-[#002347] text-white hover:bg-[#003366] transition ${
          currentIndex === allowedQuantities.length - 1
            ? "opacity-50 cursor-not-allowed"
            : ""
        }`}
      >
        <FiPlus size={16} />
      </button>
    </>
  )}

  <button
    className="px-3 py-1 bg-red-500 text-white text-sm rounded hover:bg-red-600 transition"
    onClick={() => {
      if (isSubCart) {
        removeFromSubCart(item.id);
        setTimeout(() => {
          const updatedSubCart = localStorage.getItem("sub_cart");
          const parsed = updatedSubCart ? JSON.parse(updatedSubCart) : [];
          setSubCart(parsed);

          if (parsed.length === 0) {
            setSubCartCleared(true);
          }
        }, 100);
      } else {
        removeFromCart(item.id);
      }
    }}
  >
    Remove
  </button>
</div>

          </div>
        );
      })
    )}
  </div>
</div>



            {/* Summary */}
            <div className="w-full md:w-1/3 bg-white rounded-xl shadow-md p-4 flex flex-col gap-4">

  {/* Delivery Address */}
  <div className="flex justify-between items-center">
    <h2 className="text-lg font-semibold text-gray-900">Delivery Address</h2>
    <button
      onClick={() => setShowAddressList(true)}
      className="text-[#002347] font-medium hover:underline"
    >
      {selectedAddress ? "Change" : "+ Add"} Address
    </button>
  </div>

  {/* Selected Address */}
  {selectedAddress && (
    <div className="border rounded-md p-3 text-sm text-gray-700">
      <p className="font-semibold text-gray-800">{selectedAddress.name}</p>
      <p>{selectedAddress.address}</p>
      <p>{selectedAddress.phone}</p>
    </div>
  )}

  {/* Subscription Cart Summary */}
  {isSubCart && subCart.length > 0 && (
    <div className="mt-4">
      <h2 className="text-lg font-semibold mb-2 text-gray-900">Order Summary</h2>

      <div className="flex justify-between text-gray-700">
        <span>Cart Total</span>
        <span>${cartTotal.toFixed(2)}</span>
      </div>

      <div className="flex justify-between font-bold text-lg text-gray-900">
        <span>Total</span>
        <span>${cartTotal.toFixed(2)}</span>
      </div>
    </div>
  )}

  {/* Offer message for normal cart */}
  {/* {!isSubCart && totalQuantity > 0 && totalQuantity % 2 === 0 && (
    <p className="text-sm text-red-500 mt-1 font-medium">
      Add one more toy to get the offer.
    </p>
  )} */}

  {/* Active Order Message */}
  {activeOrderMessage && (
    <div className="text-sm text-red-500 mt-2">{activeOrderMessage}</div>
  )}

  {/* TERMS CHECKBOX ONLY FOR SUB CART */}
 {isSubCart && !hasSubscribedBefore && (
  <>
    <div className="flex items-start gap-2 mt-2">
      <input
        type="checkbox"
        checked={agreeTerms}
        onChange={() => {
          setAgreeTerms(!agreeTerms);
          setTermsError("");
        }}
        className="mt-1"
      />
      <label className="text-sm text-gray-700">
  I certify that I am at least 18 years old and that I agree to the{" "}
  <span
    className="text-blue-600 underline cursor-pointer"
    onClick={() => navigate("/terms")}
  >
    Terms and Policies
  </span>{" "}
  and{" "}
  <span
    className="text-blue-600 underline cursor-pointer"
    onClick={() => navigate("/privacypolicy")}
  >
    Privacy Policy
  </span>
  . This service is for the U.S. only.
</label>

    </div>

    {termsError && (
      <p className="text-sm text-red-500 font-medium mt-1">{termsError}</p>
    )}
  </>
)}

{isSubCart ? (
  <button
    onClick={() => {
      if (!agreeTerms && !hasSubscribedBefore) {
        setTermsError("Please agree to the Terms & Conditions.");
        return;
      }
      setTermsError("");
      handleSubscriptionOrder();
    }}
    className={`mt-4 w-full py-3 rounded-lg font-medium transition ${
      displayCart.length === 0
        ? "bg-gray-400 text-gray-700 cursor-not-allowed"
        : "bg-green-500 text-white hover:bg-green-600"
    }`}
  >
    Proceed & Pay
  </button>
) : (
  <button
  onClick={handleProceed}
  className={`mt-4 w-full py-3 rounded-lg font-medium transition ${
    displayCart.length === 0
      ? "bg-gray-400 text-gray-700 cursor-not-allowed"
      : "bg-green-500 text-white hover:bg-green-600"
  }`}
>
  Confirm Order
</button>

)}
</div>

          </div>
        </section>
      </main>

      {/* Address List Modal */}
      {showAddressList && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
          <div className="bg-white rounded-lg shadow-xl p-6 w-[420px] relative">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Select an Address</h3>
              <button
                onClick={handleAddNewAddress}
                className="text-sm text-blue-600 hover:underline font-medium"
              >
                + Add New Address
              </button>
            </div>

            {addresses.length === 0 ? (
              <p className="text-gray-500">No saved addresses found.</p>
            ) : (
              <div className="flex flex-col gap-3 max-h-64 overflow-y-auto">
                {addresses.map((addr) => (
                  <div
                    key={addr.id}
                    onClick={() => setSelectedAddress(addr)}
                    className={`border rounded-md p-3 cursor-pointer transition ${
                      selectedAddress?.id === addr.id ? "border-blue-500 bg-blue-50" : "hover:bg-gray-100"
                    }`}
                  >
                    <p className="font-semibold text-gray-800">{addr.name}</p>
                    <p className="text-sm text-gray-700">{addr.address}</p>
                    <p className="text-sm text-gray-600">{addr.phone}</p>
                  </div>
                ))}
              </div>
            )}

            <div className="flex gap-3 mt-5">
              <button
                onClick={() => setShowAddressList(false)}
                className="flex-1 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 transition"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (!selectedAddress) {
                    alert("Please select an address first.");
                    return;
                  }
                  setShowAddressList(false);
                }}
                className="flex-1 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
              >
                Add This Address
              </button>
            </div>
          </div>
        </div>
      )}

    {showInfoModal && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
    <div className="bg-white p-6 rounded-xl w-80 shadow-lg">
      <h2 className="text-lg font-semibold mb-3 text-gray-900">Message</h2>
      <p className="text-gray-700 mb-4">{infoModalMessage}</p>
     <button
  onClick={async () => {
    setShowInfoModal(false);
    setModalType("email");

    try {
      const user_id = localStorage.getItem("user_id");

      const sendOtpRes = await fetch(`${BASE_URL}/user/send-otp/${user_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          type: "email", // or "mobile"
        }),
      });

      const resData = await sendOtpRes.json();
      console.log("OTP Send Response:", resData);

      if (resData.status !== 200) {
        alert(resData.message || "Failed to send OTP");
        return;
      }

      // Success → Open OTP modal
      setShowModal(true);

    } catch (err) {
      console.error("OTP API Error:", err);
      alert("Failed to send OTP");
    }
  }}
  className="w-full py-2 px-4 bg-green-500 text-white font-medium rounded-lg border border-green-600 hover:bg-green-600 hover:border-green-700 transition-colors"
>
  Verify Email / Phone
</button>



    </div>
  </div>
)}

  {/* OTP Verification Modal */}
      {showModal && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-lg flex items-center justify-center z-50 p-4"
          role="dialog"
          aria-modal="true"
          aria-labelledby="otp-modal-title"
        >
          <div className="bg-white w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-[500px] rounded-2xl shadow-lg p-4 sm:p-6 relative mx-4">
            {isVerified ? (
              <div className="flex flex-col items-center justify-center space-y-4 py-6">
                <h2
                  id="otp-modal-title"
                  className="text-base sm:text-lg font-semibold text-gray-800 text-center"
                >
                  {modalType === "email" ? "Email Verified!" : "Mobile Verified!"}
                </h2>
                <p className="text-xs sm:text-sm text-gray-500 text-center">Closing in 2 seconds...</p>
              </div>
            ) : (
              <>
                <h2
                  id="otp-modal-title"
                  className="text-center text-base sm:text-lg font-semibold text-gray-800 mb-2"
                >
                  Enter Verification Code
                </h2>
                <p className="text-center text-xs sm:text-sm text-gray-600 mb-4 px-2">
                  We've sent a 6-digit code to your {modalType === "email" ? "email" : "mobile number"}
                </p>
                <div className="flex justify-center space-x-2 sm:space-x-3 mb-6 px-2">
                  {otp.map((digit, i) => (
                    <input
                      key={i}
                      type="text"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleOtpChange(e.target.value, i)}
                      className="w-8 h-10 sm:w-10 sm:h-12 text-center border-b-2 border-gray-300 focus:border-green-500 text-base sm:text-lg focus:outline-none"
                      aria-label={`Digit ${i + 1} of verification code`}
                      pattern="[0-9]"
                      title="Enter a single digit"
                    />
                  ))}
                </div>
                <button
                  onClick={handleConfirmCode}
                  className="bg-green-500 hover:bg-green-600 text-white w-full py-2.5 sm:py-3 rounded-lg mb-3 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 text-sm sm:text-base font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={otp.join("").length !== 6}
                  aria-label="Confirm verification code"
                >
                  Confirm
                </button>
                <button
                  onClick={() => {
                    setShowModal(false);
                    setOtp(Array(6).fill(""));
                  }}
                  className="text-gray-500 hover:text-gray-700 w-full py-2 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 text-sm sm:text-base font-medium"
                  aria-label="Cancel verification"
                >
                  Cancel
                </button>
              </>
            )}
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Cartsection;
